"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInspectionSlotDto = instanceOfInspectionSlotDto;
exports.InspectionSlotDtoFromJSON = InspectionSlotDtoFromJSON;
exports.InspectionSlotDtoFromJSONTyped = InspectionSlotDtoFromJSONTyped;
exports.InspectionSlotDtoToJSON = InspectionSlotDtoToJSON;
exports.InspectionSlotDtoToJSONTyped = InspectionSlotDtoToJSONTyped;
/**
 * Check if a given object implements the InspectionSlotDto interface.
 */
function instanceOfInspectionSlotDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    return true;
}
function InspectionSlotDtoFromJSON(json) {
    return InspectionSlotDtoFromJSONTyped(json, false);
}
function InspectionSlotDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': (new Date(json['inspectionStartTime'])),
        'inspectionEndTime': json['inspectionEndTime'],
        'inspectionType': json['inspectionType'],
    };
}
function InspectionSlotDtoToJSON(json) {
    return InspectionSlotDtoToJSONTyped(json, false);
}
function InspectionSlotDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'].toISOString(),
        'inspectionEndTime': value['inspectionEndTime'],
        'inspectionType': value['inspectionType'],
    };
}
